/** Traductions modal modification achat (FR / AR) */
export const editPurchaseModalFr = {
  title: 'Modifier l\'achat',
  receiptId: 'Bon d\'achat',
  selectSupplier: 'Sélectionner un fournisseur',
  selectProduct: 'Sélectionner un produit',
  productRequired: 'Produit *',
  stockLocation: 'Emplacement du stock',
  mainStock: 'Stock principal',
  quantityLabel: 'Quantité *',
  purchasePriceLabel: 'Prix d\'achat ({{currency}}) *',
  sellingPriceOptional: 'Prix de vente ({{currency}}) (optionnel)',
  sellingPricePlaceholder: 'Prix de vente par unité',
  totalLabel: 'Total ({{currency}})',
  updatePurchase: 'Enregistrer les modifications',
  updateSuccessTitle: 'Achat modifié',
  updateSuccessMessage: 'Le bon d\'achat et le stock ont été mis à jour',
  invoiceUpdatedTitle: 'Facture mise à jour',
  invoiceUpdatedMessage: 'La facture fournisseur a été synchronisée avec l\'achat',
  saveError: 'Erreur lors de la modification',
  colStock: 'Vendu',
  soldQty: '{{sold}} vendu(s)',
  soldHint: 'Quantité déjà vendue depuis ce lot',
  cannotRemoveSold: 'Impossible de supprimer — {{sold}} unité(s) déjà vendue(s)',
  minQtySold: 'Quantité min. {{min}} ({{sold}} déjà vendu(s))'
};

export const editPurchaseModalAr = {
  title: 'تعديل الشراء',
  receiptId: 'إيصال الشراء',
  selectSupplier: 'اختر المورد',
  selectProduct: 'اختر المنتج',
  productRequired: 'المنتج *',
  stockLocation: 'موقع المخزون',
  mainStock: 'المخزون الرئيسي',
  quantityLabel: 'الكمية *',
  purchasePriceLabel: 'سعر الشراء ({{currency}}) *',
  sellingPriceOptional: 'سعر البيع ({{currency}}) (اختياري)',
  sellingPricePlaceholder: 'سعر البيع لكل وحدة',
  totalLabel: 'الإجمالي ({{currency}})',
  updatePurchase: 'حفظ التعديلات',
  updateSuccessTitle: 'تم تعديل الشراء',
  updateSuccessMessage: 'تم تحديث إيصال الشراء والمخزون',
  invoiceUpdatedTitle: 'تم تحديث الفاتورة',
  invoiceUpdatedMessage: 'تمت مزامنة فاتورة المورد مع الشراء',
  saveError: 'خطأ أثناء التعديل',
  colStock: 'مباع',
  soldQty: '{{sold}} مباع',
  soldHint: 'الكمية المباعة من هذه الدفعة',
  cannotRemoveSold: 'لا يمكن الحذف — {{sold}} وحدة مباعة',
  minQtySold: 'الحد الأدنى {{min}} ({{sold}} مباع)'
};
